import { render } from "./HighlightsWidget.vue?vue&type=template&id=8ac09696"
import script from "./HighlightsWidget.vue?vue&type=script&lang=js"
export * from "./HighlightsWidget.vue?vue&type=script&lang=js"

import "./HighlightsWidget.vue?vue&type=style&index=0&id=8ac09696&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__